const s = {
  'next': '次へ',
  'prev': '戻る',
  'select...': '選ぶ',
  'brand': 'ブランド',
  'select a date': '日にちの選択',
  'select hour': '時間の選択',
  'day': '日',
  'time': '時間',
  'location': '場所',
  'your data': 'あなたのデータ',
  'date and time': '日付と時間"',
  'num people': '参加者数',
  'err num people': '人数を選択してください',
  'workshop list': 'ワークショップ一覧',
  'signup': '新規登録',

  'first name': '名',
  'last name': '姓',
  'name': '名前',
  'appointment day': '予約日',
  'email': 'メール',
  'phone': '電話',
  'whatsapp': 'WhatsApp',
  'phone_scemi': '電話',
  'phone_scemi_placeholder': '333 12345678',
  'prefix_scemi_placeholder': '例 +39',
  'appointment type': '予約タイプ',
  'preferred contact': 'ご希望の連絡先',
  'preferred language': 'ご希望の言語',
  'product category': '商品カテゴリー',
  'notes': '注記',
  'subscribe to newsletter': 'Subscribe to newsletter',
  'slot unavailable': '選択した時間はもう利用できません',
  'choose another time slot': 'Select another time slot',
  'confirm': '確定する',
  'sending': '送信中',
  'appointment confirmed': 'ご予約いただきありがとうございます<br> ご予約確定のお知らせメールが間もなく届きます',

  'onsite': '現地',
  'online': 'オンライン',

  'italian': 'イタリア語',
  'english': '英語',
  'french': 'フランス語',
  'chinese': '中国語',
  'russian': 'ロシア語',
  'japanese': '日本語',
  'korean': '韓国語',

  'Abbigliamento Bambino': '子供服',
  'Abbigliamento Donna': 'レディースウェア',
  'Abbigliamento Uomo': 'メンズウェア',
  'Accessori': 'アクセサリー',
  'Arredamento': 'インテリアデザイン',
  'Borse': 'アクセサリー（バッグ・小物）',
  'Calzature': '靴',
  'Calzature Donna': '女性の靴',
  'Calzature Uomo': 'メンズシューズ',
  'Fragranze': 'フレグランス',
  'Gioielleria': 'ジュエリー',
  'Occhiali Da Sole': 'サングラス',
  'Orologi': '時計',
  'Pelletteria': 'Leather goods',
  'Pellicceria': 'Fur Goods',

  'fill all fields': '必須項目',
}

export default s;